<div class="row">
    <div class="col-md-12">
        <yt-eotpremnica-stavka-dodatni-atribut-inline-update
            #baseInlineUpdate
            [NestedInline]="true"
            [DetailModelData]="modelData?.MainList?.DetailList[3]"
            [Disabled]="Disabled"
        >
        </yt-eotpremnica-stavka-dodatni-atribut-inline-update>
    </div>
</div>
<div class="row">
    <div class="col-lg-12">
        <yt-fw-default-detail-list-inline 
            #baseDetailList
            [Model]="modelData.MainList.DetailList[3]" 
            [ParentPropertyName]="_parentPropertyName"
            [ParentPropertyValue]="_parentPropertyValue"
            [Disabled]="!_parentPropertyValue || _parentPropertyValue <= 0 || Disabled"             
            (Items)="setItems($event)"
        >
        </yt-fw-default-detail-list-inline>
    </div>
</div>